import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { ProhibitIcon } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// OD-13 · WO-screen Reject via the existing WO rejection service (production_orders:reject, Pending only).
export const WoRejectDialog = ({ wo, onClose, onDone }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setReason(""); }, [wo?.id]);
  const ok = reason.trim().length >= 4;
  const confirm = async () => {
    if (!ok) { toast.error("Rejection reason is required (min 4 characters)"); return; }
    setBusy(true);
    try {
      await api.post(`/approvals/doc/wo/${wo.id}/reject`, { reason: reason.trim() });
      toast.success(`${wo.po_no} rejected`);
      onClose();
      await onDone();
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : d?.message || "Reject failed");
    } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!wo} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="bg-[var(--bg-1)] border-[var(--border)] text-white max-w-md" data-testid="wo-reject-dialog" description="Reject a Work Order pending authorisation with a mandatory reason.">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-300"><ProhibitIcon size={18} weight="bold" /> Reject Work Order</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-1">
          <div className="text-sm text-zinc-400">Work Order: <span className="font-mono text-white" data-testid="wo-reject-docno">{wo?.po_no || "—"}</span></div>
          <label className="block text-xs font-mono uppercase tracking-widest text-zinc-400">Rejection Reason <span className="text-red-400">*</span> · Reason required</label>
          <textarea data-testid="wo-reject-reason" rows={3} value={reason} onChange={(e) => setReason(e.target.value)}
            placeholder="Enter the reason for rejecting this Work Order (min 4 characters)"
            className="w-full px-3 py-2 bg-[var(--bg-0)] border border-[var(--border)] rounded-sm text-white text-sm focus:outline-none focus:border-red-500/60" />
        </div>
        <DialogFooter className="gap-2">
          <button data-testid="wo-reject-back" onClick={onClose} className="px-4 py-2 rounded-sm border border-[var(--border)] text-sm text-zinc-400">Back</button>
          <button data-testid="wo-reject-confirm" onClick={confirm} disabled={busy || !ok}
            className="px-4 py-2 rounded-sm bg-red-600 hover:bg-red-700 disabled:bg-zinc-700 disabled:cursor-not-allowed text-sm font-semibold text-white flex items-center gap-2">
            <ProhibitIcon size={14} weight="bold" /> Reject Work Order
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
